import { Omit } from 'bold-ui'
import { SelectField, SelectFieldProps } from 'components/form/final-form'
import { TipoTratamentoAguaEnum } from 'graphql/types.generated'
import React from 'react'

import { tipoTratamentoAguaEnumRecord, tipoTratamentoAguaValidoEnumList } from './condicoes-moradia-model'

export interface TipoTratamentoAguaSelectFieldProps
  extends Omit<SelectFieldProps<TipoTratamentoAguaEnum>, 'items' | 'itemToString'> {
  showItensLegados: Boolean
}

export function TipoTratamentoAguaSelectField(props: TipoTratamentoAguaSelectFieldProps) {
  const items = props.showItensLegados ? allItems : tipoTratamentoAguaValidoEnumList
  return <SelectField<TipoTratamentoAguaEnum> items={items} itemToString={itemToString} {...props} />
}

const allItems = Object.values(TipoTratamentoAguaEnum)
const itemToString = (item: TipoTratamentoAguaEnum) => item && tipoTratamentoAguaEnumRecord[item]
